/* «اختيار سندس» strip (sections/sondos-promo-strip.liquid).
   The track is LTR with its cards reversed by `order`, so the first card sits at the
   right end: index 0 = scrollLeft at its maximum. Each card prints its own «i/N», so
   the script only parks the track and rotates it every 5s while on screen; it stops
   for good once the visitor touches it. */
(function () {
  function init(root) {
    if (root.dataset.spsReady) return;
    root.dataset.spsReady = '1';
    var track = root.querySelector('[data-sps-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var n = cards.length;
    if (!n) return;

    var touched = false;
    var visible = false;
    var timer = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // One step = a card plus the gap after it.
    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (cards[0].offsetWidth || track.clientWidth || 1) + gap;
    }
    function max() { return track.scrollWidth - track.clientWidth; }
    function index() {
      var i = Math.round((max() - track.scrollLeft) / step());
      return Math.min(n - 1, Math.max(0, i));
    }
    function leftOf(i) { return max() - step() * i; }
    function park() { if (!touched) track.scrollLeft = leftOf(0); }

    // At parse time scrollWidth is 0, and Almarai arrives after first paint.
    requestAnimationFrame(park);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(park);

    // Two cards share the view from 750px: the last stop is n - perView, then wrap.
    function perView() { return Math.max(1, Math.round((track.clientWidth + 1) / step())); }
    function tick() {
      if (touched || !visible || document.hidden) return;
      var next = index() + 1;
      if (next > n - perView()) next = 0;
      track.scrollTo({ left: leftOf(next), behavior: 'smooth' });
    }
    function start() { if (reduce || n <= perView() || touched || timer) return; timer = setInterval(tick, 5000); }
    function stop() { clearInterval(timer); timer = 0; }
    function hold() { touched = true; stop(); }

    root.addEventListener('pointerdown', hold, { passive: true });
    root.addEventListener('touchstart', hold, { passive: true });
    root.addEventListener('focusin', hold);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Off-screen cards sit beside the strip, outside the lazy-load margin, so their
    // packs would arrive blank on the first rotation. Fetch them once the strip nears.
    function warm() {
      root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, io) {
        if (entries[0].isIntersecting) { warm(); io.disconnect(); }
      }, { rootMargin: '400px 0px' }).observe(root);
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.5 }).observe(root);
    } else {
      warm();
      visible = true;
      start();
    }

    window.addEventListener('resize', function () {
      var i = index();
      requestAnimationFrame(function () { track.scrollLeft = leftOf(i); });
    });
  }

  function boot() { document.querySelectorAll('[data-sps]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
